import React, {Component} from "react"
import {Container, Header, Loader, Segment} from "semantic-ui-react";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, parseMultilineString} from "../utils/localization";
import {EXPIRED_ROUTE, resolveErrorMessage} from "../utils/common";
import Footer from "./footer";
import {SupportEmailLink} from "./base";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import {ResetTokenRequest} from "../services/types";
import {resetToken} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData} = state;
    return {
        ...ownProps,
        lang: user.lang,
        token: initialData.token,
        resetTokenEmail: user.resetTokenEmail,
    }
};

class RequestSent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    handleReSend = async () => {
        const localization = getLocalization(this.props.lang);
        const strings = localization.expiredToken;

        const handleError = (message) => {
            this.setState({loading: false, error: true, message});
        }

        try {
            this.setState({loading: true, error: false});
            const {token, resetTokenEmail} = this.props;
            const request = new ResetTokenRequest({
                email: resetTokenEmail,
                token
            });
            let result = await resetToken(request);
            if (result.status === 200) {
                this.setState({loading: false});
                window.onbeforeunload = null;
                this.props.history.push("/requestSent");
            } else {
                handleError(strings.error);
            }
        } catch (e) {
            handleError(resolveErrorMessage(e, strings.error));
        }
    }

    render() {
        const {loading} = this.state;
        const localization = getLocalization(this.props.lang);
        const strings = localization.requestToken;

        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <CustomGrid container stackable centered fitted={'horizontally'}>
                        <CustomGrid.Column style={{marginTop: '5em'}} width={6}>
                            <Segment style={{padding: '3em 4em 2em 4em'}}>
                                {loading ? (
                                    <Loader active={true}/>
                                ):(
                                    <React.Fragment>
                                        <S3Image {...IMAGE.CHECK}/>
                                        <Header as={"h3"} textAlign={"center"}>{strings.title}</Header>

                                        <p>{strings.descr}</p>

                                        <Segment>
                                            <p className={"smaller"}>
                                                <b>{strings.didntReceive}</b><br/>
                                                {strings.either}
                                                <a href onClick={this.handleReSend}>{strings.reSend}</a>
                                                {strings.to}
                                                <Link to={EXPIRED_ROUTE}>{strings.tryDiff}</Link>
                                            </p>
                                        </Segment>
                                    </React.Fragment>
                                )}
                            </Segment>
                            <Segment basic style={{padding: '1em 4em'}}>
                                <p className={"smaller"}>
                                    {parseMultilineString(strings.stillNeed)}
                                    <SupportEmailLink/>
                                </p>
                            </Segment>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer hideLimitationsAndExclusions={true}/>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(RequestSent));
